import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ITariffList } from '../../../Pages/Tariff/ITariff';

interface IUpdate extends IReduxState<ITariffList> {
  updateableDate?: ITariffList;
}

export const UpdateTariffSlicer = createSlice({
  name: 'UpdateTariff',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateTariff: (state, _) => {
      state.isLoading = true;
    },
    successUpdateTariff: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateTariff: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    TariffUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateTariffState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateTariff,
  failureUpdateTariff,
  successUpdateTariff,
  TariffUpdateableData,
  clearUpdateTariffState,
  clearUpdateableData,
} = UpdateTariffSlicer.actions;

export default UpdateTariffSlicer.reducer;
